import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=4c158335&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=4c158335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c158335",
  null
  
)

export default component.exports